module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"baja cargo solutions","short_name":"starter","start_url":"/","background_color":"#00457D","theme_color":"#00457D","display":"minimal-ui","icon":"src/images/bcs-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"025a25dff20eab0fa4025331b1e363fa"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
